"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleRowPaymentAmountFormula = void 0;
exports.getScheduleRowPaymentAmount = getScheduleRowPaymentAmount;
const general_formulas_1 = require("./general-formulas");
/*
 * Enumeration of ScheduleRowPaymentAmount formala implementation names
 */
var ScheduleRowPaymentAmountFormula;
(function (ScheduleRowPaymentAmountFormula) {
    ScheduleRowPaymentAmountFormula[ScheduleRowPaymentAmountFormula["DEFAULT"] = 0] = "DEFAULT";
})(ScheduleRowPaymentAmountFormula || (exports.ScheduleRowPaymentAmountFormula = ScheduleRowPaymentAmountFormula = {}));
/**
 * Returns the specified draw fee formula implementation
 */
function getScheduleRowPaymentAmount(formula) {
    switch (formula) {
        default:
            return default_scheduleRowPaymentAmount;
    }
}
///////////////////////////
// Function Implementations
///////////////////////////
const default_scheduleRowPaymentAmount = (params) => {
    // ensure valid argument types
    if (typeof params.paymentIndex === 'number' && typeof params.paymentCount === 'number' && typeof params.paymentAmount === 'number'
        && typeof params.previousRow === 'object' && typeof params.currentRow === 'object') {
        if (params.paymentCount == 1) {
            return params.startBalance + params.currentRow.interestAmount;
        }
        else {
            return (0, general_formulas_1.toFixedNumber)(params.paymentIndex < params.paymentCount - 1 ? params.paymentAmount : params.previousRow.endBalance + params.currentRow.interestAmount, 2);
        }
    }
    return NaN;
};
//# sourceMappingURL=schedule-row-payment-amount-formula.js.map